import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions,URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { Angular2TokenService } from 'angular2-token';
import { AuthService } from '../../authentication/auth.service';
import { environment } from '../../../environments/environment';
import {Lead} from './lead';

@Injectable()
export class LeadService {

  options: RequestOptions;

  private leadUrl = environment.apiBaseUrl+'/v1/leads';

  constructor(
    private http: Http,
    private tokenService: Angular2TokenService,
    private authService: AuthService
  ) {
    this.options = this.authService.getHeaders();
  }

  changeStatus(id:Number) :Observable<Lead> {
    let url = this.leadUrl+'/'+id+'/approve_user';
    return this.http.patch(url,id, this.options
    ).map((res: Response) => res.json());
  }
  private extractData(res: Response) {
    let body = res.json();
    return body;
  }

  private extractDataPage(res:Response){
    return res;
  }
  private handleErrorObservable (error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.message || error);
  }

  getLeadList(lead_source): Observable<Lead[]>{
    let params: URLSearchParams = new URLSearchParams();
      params.set('source', lead_source);
      this.options.search = params;
      return this.http.get(this.leadUrl,this.options)
      .map(this.extractData)
      .catch(this.handleErrorObservable);

  }

  filteredLeads(lead_source,colName,from_date,to_date){
    var params: URLSearchParams = new URLSearchParams();
    params.set('source', lead_source);
    params.set('column_name',colName);
    params.set('from_date',from_date);
    params.set('to_date',to_date);
    var opt = this.options;
    opt.search = params;

    return this.http.get(this.leadUrl,opt)
      .map(this.extractData)
      .catch(this.handleErrorObservable);
  }

  addLead(data){
    if(this.options.params){
      this.options.params.delete('source');
      this.options.params.delete('lead_status');
      this.options.params.delete('lead_type_id');
      this.options.params.delete('lead_campaign_id');
      this.options.params.delete('column_name');
      this.options.params.delete('from_date');
       this.options.params.delete('lead_source_id');
      this.options.params.delete('to_date');
      this.options.params.delete('cs_agent');
      this.options.params.delete('search');
    }
    return this.http.post(this.leadUrl,data,this.options)
            .map(this.extractData)
            .catch(this.handleErrorObservable);
  }


  designerAddLead(data){
    var url = environment.apiBaseUrl+'/v1/leads/designer_lead_add';
      if(this.options.params){
        this.options.params.delete('source');
        this.options.params.delete('lead_status');
        this.options.params.delete('lead_type_id');
        this.options.params.delete('lead_campaign_id');
        this.options.params.delete('column_name');
        this.options.params.delete('from_date');
         this.options.params.delete('lead_source_id');
        this.options.params.delete('to_date');
        this.options.params.delete('cs_agent');
        this.options.params.delete('search');
      }
      return this.http.post(url,data,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
  }

   deleteLead(id:Number):Observable<Lead[]> {
      let headers= this.authService.getHeaders();
      let url = this.leadUrl+'/'+id;
      return this.http.delete(url, headers)
        .map(this.extractData)
        .catch(this.handleErrorObservable);
    }

    viewLeadDetails(id:Number): Observable<Lead[]>{
      let url = this.leadUrl+'/'+id;
      return this.http.get(url,this.options)
        .map(this.extractData)
        .catch(this.handleErrorObservable);
    }

    editLead(id:Number, params:any){
      let url = this.leadUrl+'/'+id;
      return this.http.patch(url,params,this.options)
        .map(this.extractData)
        .catch(this.handleErrorObservable);
    }

    postRecordNotesQuestionnaire(lead_id,data) {
      let url = environment.apiBaseUrl+'/v1/note_records';
      let params: URLSearchParams = new URLSearchParams();
      params.set('ownerable_id', lead_id+'');
      params.set('ownerable_type', 'Lead');
      this.options.search = params;

      return this.http.post(url,data,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }
    updateRecordNotesQuestionnaire(lead_id,data,noteRecordId) {
      let url = environment.apiBaseUrl+'/v1/note_records/'+noteRecordId;
      let params: URLSearchParams = new URLSearchParams();
      params.set('ownerable_id', lead_id+'');
      params.set('ownerable_type', 'Lead');
      this.options.search = params;

      return this.http.patch(url,data,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }
    getRecordNotesQuestionnaire(lead_id) {
      let url = environment.apiBaseUrl+'/v1/note_records';
      let params: URLSearchParams = new URLSearchParams();
      params.set('ownerable_id', lead_id+'');
      params.set('ownerable_type', 'Lead');
      this.options.search = params;
      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }

    uploadLeadExcel(files: File[],leadSource,type,camp) {
      let leads = {
        'attachment_file' : files,
        'lead_source_id':leadSource,
        'lead_type_id':type,
        'lead_campaign_id':camp
      }
      let headers= this.authService.getHeaders();
      let url = this.leadUrl+'/import_leads';
      return this.http.post(url,leads,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);
    }

    getacallbackLeadsDetails(){
      let url = environment.apiBaseUrl+'/v1/contacts';
      return this.http.get(url,this.options)
        .map(this.extractData)
        .catch(this.handleErrorObservable);
    }

    deleteGetACallbackLead(id:number) {
      let url = environment.apiBaseUrl+'/v1/contacts/'+id;
      return this.http.delete(url,this.options)
        .map(this.extractData)
        .catch(this.handleErrorObservable);
    }

    exportLeads(role){
      let url = this.leadUrl+'/download_leads';
      let params: URLSearchParams = new URLSearchParams();
      params.set('role',role);
      this.options.search = params;
      return this.http.get(url,this.options)
        .map(response => {
                if (response.status == 400) {
                    this.handleErrorObservable;
                } else if (response.status == 200) {
                    // var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    // //var blob = response['_body'];
                    // var blob = new Blob([(<any>response)._body], { type: contentType });
                   // var url = environment.apiBaseUrl+'/'+response['_body'];
                    return response;
                }
            })
        .catch(this.handleErrorObservable);
    }

    exportLeads1(role,source,lead_status,lead_type_id,lead_source_id,
      lead_campaign_id,column_name,from_date,to_date,cs_agent_list,search){
      let url = this.leadUrl+'/download_leads';
      let params: URLSearchParams = new URLSearchParams();
      params.set('role',role);
      params.set('source', source);
      params.set('lead_status',lead_status);
      params.set('lead_type_id',lead_type_id);
      params.set('lead_source_id',lead_source_id);
      params.set('lead_campaign_id',lead_campaign_id);
      params.set('column_name',column_name);
      params.set('from_date',from_date);
      params.set('to_date',to_date);
      params.set('cs_agent',cs_agent_list);
      params.set('search',search);
      this.options.search = params;
      return this.http.get(url,this.options)
        .map(response => {
                if (response.status == 400) {
                    this.handleErrorObservable;
                } else if (response.status == 200) {
                    // var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    // //var blob = response['_body'];
                    // var blob = new Blob([(<any>response)._body], { type: contentType });
                   // var url = environment.apiBaseUrl+'/'+response['_body'];
                    return response;
                }
            })
        .catch(this.handleErrorObservable);
    }

    updateLeadStatus(data,id) {
      let url = this.leadUrl+'/'+id+'/update_status';
      if(this.options.params){
        this.options.params.delete('role');
      }
      return this.http.post(url,data,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }

    escalatedleads() {
      let url = this.leadUrl + "/escalated_leads";
      return this.http.get(url,this.options)
        .map(this.extractData)
        .catch(this.handleErrorObservable);
    }

    requestRole(role:string) {
      let url = environment.apiBaseUrl+ '/v1/users/request_role';
      let params: URLSearchParams = new URLSearchParams();
      params.set('role', role);
      this.options.search = params;
      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);

    }
    assignLeadToAgent(agentId,leadId) {
      let url = environment.apiBaseUrl+ '/v1/leads/'+leadId+'/assign_lead';
      let params: URLSearchParams = new URLSearchParams();
      params.set('agent_id', agentId);
      this.options.search = params;
      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }
    assigndesignerToCM(agentId,leadId) {
      let url = environment.apiBaseUrl+ '/v1/users/assign_designer_to_cm';
      var obj = {
        'cm_id':agentId,
        'designer_id':leadId
      }
      return this.http.post(url,obj,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }
    refreshLeads(agentId,lead_id,lead) {
      let url = environment.apiBaseUrl+'/v1/leads/refresh_leads';
      let params: URLSearchParams = new URLSearchParams();
      params.set('agent_id', agentId);
      this.options.search = params;
       return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }

    callToLead(userId, leadId){
      let url = environment.apiBaseUrl+'/v1/users/'+userId+'/call_user';
      let obj ={
        'user':userId,
        'lead_id': leadId
      };
      return this.http.post(url,obj,this.options).map(this.extractData).catch(this.handleErrorObservable);
    }

    getCommunityManagersList(){
      let url = environment.apiBaseUrl+'/v1/users/designer_cm_index';
      return this.http.get(url,this.options)
            .map(this.extractData)
            .catch(this.handleErrorObservable);
    }

    getDesignerLeads(){
      let url = this.leadUrl+'/designer_leads';
      return this.http.get(url,this.options)
            .map(this.extractData)
            .catch(this.handleErrorObservable);
    }

    getLeadLog(leadId){
      let url = environment.apiBaseUrl+'/v1/leads/'+leadId+'/show-logs';
      return this.http.get(url,this.options)
               .map(this.extractData)
               .catch(this.handleErrorObservable);

    }
    getSiteSupervisorList(){
      let url = environment.apiBaseUrl+'/v1/users/sitesupervisor_users';
      return this.http.get(url,this.options)
            .map(this.extractData)
            .catch(this.handleErrorObservable);
    }
    getFileterLeads(source,lead_status,lead_type_id,lead_source_id,
      lead_campaign_id,column_name,from_date,to_date,cs_agent_list,search,page?){
      let url = environment.apiBaseUrl+'/v1/leads/filtered_index?page='+page;
      var params: URLSearchParams = new URLSearchParams();
      params.set('source', source);
      params.set('lead_status',lead_status);
      params.set('lead_type_id',lead_type_id);
      params.set('lead_source_id',lead_source_id);
      params.set('lead_campaign_id',lead_campaign_id);
      params.set('column_name',column_name);
      params.set('from_date',from_date);
      params.set('to_date',to_date);
      params.set('cs_agent',cs_agent_list);
      params.set('search',search);
      this.options.search = params;
      return this.http.get(url,this.options)
              .map(this.extractDataPage)
              .catch(this.handleErrorObservable);
    }

    getFiltersData(){
      let url = environment.apiBaseUrl+'/v1/leads/filter_details';
      var params: URLSearchParams = new URLSearchParams();
      this.options.search = params;
      return this.http.get(url,this.options).map(this.extractDataPage).catch(this.handleErrorObservable);
    }

    getLeadHeadCount(lead_type_id,lead_source_id,lead_campaign_id,from_date,to_date){
      let url = environment.apiBaseUrl+'/v1/leads/lead_head_dashboard_count';
       var params: URLSearchParams = new URLSearchParams();
        params.set('lead_type_id',lead_type_id);
        params.set('lead_source_id',lead_source_id);
        params.set('lead_campaign_id',lead_campaign_id);
        params.set('from_date',from_date);
        params.set('to_date',to_date);
        var opt = this.options;
        opt.search = params;
      return this.http.get(url,opt)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }

    getLeadLogs(leadId){
      let url = environment.apiBaseUrl+'/v1/leads/'+leadId+'/get_lead_info';

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }

    getFloorplans(projectId){
      let url = environment.apiBaseUrl+'/v1/projects/'+projectId+'/floorplans';

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }

    getProposalList(){
      let url = environment.apiBaseUrl+'/v1/proposals';

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);

    }

    assignSiteSupervisorToCm(sitesupervisor_id,cm_id){
      let obj = {
        'cm_id' : cm_id,
        'sitesupervisor_id':sitesupervisor_id
      }
      let headers= this.authService.getHeaders();
      let url = environment.apiBaseUrl+'/v1/users/assign_sitesupervisor_to_cm';
      return this.http.post(url,obj,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);
    }

    createSiteRequest(formdata){
      let obj = {
        'site_measurement_request' : formdata,
      }
      let headers= this.authService.getHeaders();
      let url = environment.apiBaseUrl+'/v1/requests';
      return this.http.post(url,obj,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);
    }

    fetchRequirementForm(project_id){
      let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/get_project_requirement';

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }

    requirementFormSubmit(formdata){
      let obj = {
        'project_requirement' : formdata,
      }
      let headers= this.authService.getHeaders();
      let url = environment.apiBaseUrl+'/v1/project_requirements';
      return this.http.post(url,obj,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);

    }

    requirementFormUpdate(formdata, req_id){
      let obj = {
        'project_requirement' : formdata,
      }
      let headers= this.authService.getHeaders();
      let url = environment.apiBaseUrl+'/v1/project_requirements/'+req_id;
      return this.http.patch(url,obj,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);
    }

    fetchScopeForm(project_id){
      let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/scope_of_work_for_ten_percent';

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }

    scopeFormSubmit(formdata){
      let obj = {
        'scope_of_work' : formdata,
      }
      let headers= this.authService.getHeaders();
      let url = environment.apiBaseUrl+'/v1/scope_of_works';
      return this.http.post(url,obj,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);

    }

    scopeFormUpdate(formdata, req_id){
      let obj = {
        'scope_of_work' : formdata,
      }
      let headers= this.authService.getHeaders();
      let url = environment.apiBaseUrl+'/v1/scope_of_works/'+req_id;
      return this.http.patch(url,obj,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);
    }

    fetchBookingForm(project_id){
      let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/booking_form_for_project';

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }

    bookingFormSubmit(formdata){
      let obj = {
        'project_booking_form' : formdata,
      }
      let headers= this.authService.getHeaders();
      let url = environment.apiBaseUrl+'/v1/project_booking_forms';
      return this.http.post(url,obj,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);
    }

    bookingFormUpdate(id,formdata){
      let obj = {
        'project_booking_form' : formdata,
      }
      let headers= this.authService.getHeaders();
      let url = environment.apiBaseUrl+'/v1/project_booking_forms/'+id;
      return this.http.patch(url,obj,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);
    }

    fetchSiteRequest(project_id){
      let url = environment.apiBaseUrl+'/v1/requests?project_id='+project_id;

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }

    getGallery(req_id){
    let url = environment.apiBaseUrl+'/v1/requests/'+req_id+'/get_images_for_request';
    return this.http.get(url,this.options)
    .map(this.extractData)
    .catch(this.handleErrorObservable);
  }

  getApprovedBoqList(projectId, stage){
    let url = environment.apiBaseUrl+'/v1/projects/'+projectId+'/approved_quotations?stage='+stage;
    return this.http.get(url,this.options)
    .map(this.extractData)
    .catch(this.handleErrorObservable);

  }

  fetchCadElevation(project_id){
      let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/cad_drawings';

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }
  fetchPptlist(project_id){
      let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/boq_and_ppt_uploads/get_ppts';

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }
  fetchBoqList(project_id){
      let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/boq_and_ppt_uploads/get_boqs';

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    }

  uploadCad(project_id,postData){

      let headers= this.authService.getHeaders();
      let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/cad_drawings';
      return this.http.post(url,postData,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);
  }
  uploadPpt(project_id,postData){

      let headers= this.authService.getHeaders();
      let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/boq_and_ppt_uploads';
      return this.http.post(url,postData,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);
  }
  uploadBoq(project_id,postData){

      let headers= this.authService.getHeaders();
      let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/boq_and_ppt_uploads';
      return this.http.post(url,postData,headers)
                  .map(this.extractData)
                  .catch(this.handleErrorObservable);
  }

  deleteCad(id:Number,fpid:Number){

      let url = environment.apiBaseUrl + '/v1/projects/'+id+'/cad_drawings/'+fpid;
      return this.http.delete(url,this.options)
          .map(this.extractData)
        .catch(this.handleErrorObservable);
    }

  deleteSiteMeasurement(imgid:Number){

      let url = environment.apiBaseUrl + '/v1/requests/remove_images_from_request?image_id='+imgid;
      return this.http.get(url,this.options)
          .map(this.extractData)
        .catch(this.handleErrorObservable);
    }

  deleteBoq(id:Number,fpid:Number){

      let url = environment.apiBaseUrl + '/v1/projects/'+id+'/boq_and_ppt_uploads/'+fpid;
      return this.http.delete(url,this.options)
          .map(this.extractData)
        .catch(this.handleErrorObservable);
  }
  deletePpt(id:Number,fpid:Number){

      let url = environment.apiBaseUrl + '/v1/projects/'+id+'/boq_and_ppt_uploads/'+fpid;
      return this.http.delete(url,this.options)
          .map(this.extractData)
        .catch(this.handleErrorObservable);
  }
  shareWithCustomer(projectId,docId){
    let url = environment.apiBaseUrl+'/v1/projects/'+projectId+'/boq_and_ppt_uploads/'+docId+'/share_with_customer';
    return this.http.get(url,this.options)
          .map(this.extractData)
          .catch(this.handleErrorObservable);
  }

  getCitiesForQuestionnaire(){
    let url = environment.apiBaseUrl+'/v1/cities';
    return this.http.get(url,this.options)
          .map(this.extractData)
          .catch(this.handleErrorObservable);
  }

  getCmList(){
    let url = environment.apiBaseUrl+'/v1/users/list_of_cm';
    return this.http.get(url,this.options)
          .map(this.extractData)
          .catch(this.handleErrorObservable);
  }
  assignCmToLead(cmid,leadid){
    let url = environment.apiBaseUrl+'/v1/leads/'+leadid+'/assign_cm_to_lead';
    var obj={
      cm_id:cmid
    }
    return this.http.post(url,obj,this.options)
          .map(this.extractData)
          .catch(this.handleErrorObservable);
  }

  migrateCMData(from_id,to_id){
    let url = environment.apiBaseUrl+'/v1/users/migrate_cm_data';
     var obj={
      from_id:from_id,
      to_id:to_id
    }
    return this.http.post(url,obj,this.options)
          .map(this.extractData)
          .catch(this.handleErrorObservable);
  }
  cmAssignedData(cm_id){
    let url = environment.apiBaseUrl+'/v1/users/cm_assigned_data?cm_id='+cm_id;
     return this.http.get(url,this.options)
          .map(this.extractData)
          .catch(this.handleErrorObservable);
  }
  getLeadPriorityQueueData(){
    let url = environment.apiBaseUrl+'/v1/leads/lead_queue';
    return this.http.get(url,this.options)
          .map(this.extractData)
          .catch(this.handleErrorObservable);
  }

}




// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/lead/lead.service.ts